<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="main-container">
    <div class="vx-row mt-5 mb-2">
      <div class="vx-col sm:w-1/2 w-full mb-1">
        <h1>{{ company.name }} (ID: {{ company.company_id }})</h1>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-1">
        <vs-card>
          <div slot="media">
            <div class="vx-row m-2 p-2">
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  class="w-full"
                  v-on:keydown.enter="saveCompany"
                  label="Company Name"
                  v-model="workingCompany.name"
                  :description-text="workingCompany.name !== company.name ? `Press 'Enter' to save changes` : ''"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <!--   ACTIVE   -->
                <label class="label" for="active-switch">Active</label>
                <vs-switch
                  id="active-switch"
                  color="success"
                  v-bind:checked="activeBool"
                  v-on:input="toggleActive"/>

              </div>
              <!--              <vs-button class="ml-auto" color="danger" icon="delete_outline" type="gradient" >Delete Company</vs-button>-->
            </div>
          </div>

        </vs-card>
      </div>
    </div>


    <div class="vx-row mt-1">
      <div class="vx-col sm:w-1/2 w-full mb-1">
        <company-ranks-editor-card :company="workingCompany"></company-ranks-editor-card>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-1">
        <company-groups-editor-card :company="company"></company-groups-editor-card>
      </div>
    </div>
<!--    <div class="mt-5" v-html="jsonHtml.toHtml(company)"></div>-->
  </div>
</template>

<script>
  import api from '@/http/api';
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import helpers from '@/models/helpers';
  import CompanyRanksEditorCard from './ranks/CompanyRanksEditorCard';
  import CompanyGroupsEditorCard from './groups/CompanyGroupsEditorCard';

  export default {
    components: {
      CompanyRanksEditorCard,
      CompanyGroupsEditorCard,
    },
    mounted() {
      this.fetchAll();
    },
    data() {
      return {
        jsonHtml: jsonHtml,
        isLoading: false,
        company: new types.Company(),
        workingCompany: new types.Company(),
        cyclopedias: [new types.Cyclopedia()],
        currentLocalization: new types.Localization(),
        languages: [new types.Language()],
        allProductTypes: [new types.ProductType()],
        helpers: helpers,
      }
    },
    computed: {
      companyId() {
        return this.$route.query.id || null;
      },
      activeBool() {
        return this.workingCompany.active === 1;
      },
      defaultLanguageId() {
        return Number(this.$route.query.lang) || null;
      },
      howManyUnsavedChanges() {
        let count = 0;
        let keys = Object.keys(this.unsavedChanges);
        for (let i = 0; i < keys.length; i++) {
          if (this.unsavedChanges[keys[i]]) {
            count++;
          }
        }
        return count;
      },
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      async saveCompany() {
        if (JSON.stringify(this.workingCompany) === JSON.stringify(this.company)) return;

        const company = await api.patchCompany(this.workingCompany);
        if (company === null) {
          this.showNotification(false, `Error updating ${this.company.name}`);
          this.setCompanyCopies(this.company);
          return;
        }

        this.showNotification(true, `${company.name} updated successfully`);

        this.setCompanyCopies(company);

      },
      toggleActive() {
        if (this.activeBool) {
          this.workingCompany.active = 0;
        } else {
          this.workingCompany.active = 1;
        }
        this.saveCompany();
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'
        });
      },
      fetchAll() {
        this.isLoading = true;
        Promise.all([
          this.fetchCompany(),
        ]).then(() => {
          this.isLoading = false;
        });
      },
      async fetchCompany() {
        const company = await api.fetchLeanCompany(this.companyId);
        console.log(company);
        this.setCompanyCopies(company);
      },
      setCompanyCopies(company) {
        this.company = company;
        this.workingCompany = new types.Company(this.company);
      },
    },
  }

</script>


<style lang="scss">
  #main-container {

    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

